import React, { useEffect } from 'react';
import Icon from './Icon';

interface ModalProps {
  open: boolean;
  title: string;
  onClose: () => void;
  children: React.ReactNode;
  width?: number;
}

const Modal: React.FC<ModalProps> = ({
  open,
  title,
  onClose,
  children,
  width = 760,
}) => {
  useEffect(() => {
    if (!open) return;
    const onKey = (e: KeyboardEvent) => {
      if (e.key === 'Escape') onClose();
    };
    document.addEventListener('keydown', onKey);
    return () => document.removeEventListener('keydown', onKey);
  }, [open, onClose]);

  if (!open) return null;

  return (
    <div
      role="dialog"
      aria-modal="true"
      onClick={onClose}
      style={{
        position: 'fixed',
        inset: 0,
        zIndex: 1000,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        background: 'rgba(0,0,0,.4)',
        backdropFilter: 'blur(4px)',
        animation: 'fadeIn .2s ease both',
      }}
    >
      <div
        onClick={(e) => e.stopPropagation()}
        style={{
          background: '#fff',
          borderRadius: 20,
          width,
          maxWidth: 'calc(100vw - 32px)',
          maxHeight: '90vh',
          overflow: 'auto',
          boxShadow: '0 24px 48px rgba(0,0,0,.16)',
        }}
      >
        <div
          className="flex justify-between items-center gap-3 px-5 py-4 sm:px-7 sm:py-5"
          style={{ borderBottom: '1px solid var(--g100)' }}
        >
          <span className="text-lg font-bold min-w-0">{title}</span>
          <button
            type="button"
            onClick={onClose}
            aria-label="Close"
            style={{
              background: 'var(--g100)',
              border: 'none',
              borderRadius: 10,
              width: 36,
              height: 36,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              cursor: 'pointer',
              flexShrink: 0,
            }}
          >
            <Icon name="x-circle" size={18} color="var(--g600)" />
          </button>
        </div>
        <div className="px-5 pt-5 pb-6 sm:px-7 sm:pt-6 sm:pb-7">{children}</div>
      </div>
    </div>
  );
};

export default Modal;
